import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Palette } from '@woundtech/ui-colors';
import React from 'react';
import { attributeTextStyles } from './AttributeItemTextStyles';

const AttributeListItemLabel: React.FC<{
  text: string;
  variant?: 'small' | 'large' | 'verysmall';
  labelColor?: string
}> = ({ text, variant = 'small', labelColor = Palette.Gray.MediumDarker }) => {
  const classes = attributeTextStyles();
  return (
    <Box pr={1} color={labelColor}>
      <Typography className={classes[variant]} noWrap color="inherit">
        {text}
      </Typography>
    </Box>
  );
};

export default React.memo(AttributeListItemLabel);
